// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import clsx from 'clsx';
import { BreadcrumbGroupImplementation } from '../../../breadcrumb-group/implementation';
import { BreadcrumbsSlotContext } from '../contexts';
import testutilStyles from '../../test-classes/styles.css.js';
import toolbarStyles from '../toolbar/styles.css.js';
import styles from './styles.css.js';
export const ToolbarSlot = React.forwardRef(({ className, style, children }, ref) => {
    var _a;
    return (React.createElement("section", { ref: ref, className: clsx(styles['toolbar-container'], toolbarStyles['universal-toolbar'], testutilStyles.toolbar, className), style: {
            insetBlockStart: (_a = style === null || style === void 0 ? void 0 : style.insetBlockStart) !== null && _a !== void 0 ? _a : 0,
            ...style,
        } }, children));
});
export const NotificationsSlot = React.forwardRef(({ className, style, children }, ref) => (React.createElement("div", { ref: ref, className: clsx(styles['notifications-container'], className), style: style }, children)));
const breadcrumbsSlotContextValue = { isInToolbar: true };
export function BreadcrumbsSlot({ ownBreadcrumbs, discoveredBreadcrumbs }) {
    const isSSR = typeof window === 'undefined';
    return (React.createElement(BreadcrumbsSlotContext.Provider, { value: breadcrumbsSlotContextValue },
        React.createElement("div", { className: styles['breadcrumbs-own'] }, ownBreadcrumbs),
        discoveredBreadcrumbs && !isSSR && (React.createElement("div", { className: styles['breadcrumbs-discovered'] },
            React.createElement(BreadcrumbGroupImplementation, { ...discoveredBreadcrumbs, "data-awsui-discovered-breadcrumbs": true, __injectAnalyticsComponentMetadata: true })))));
}
//# sourceMappingURL=slots.js.map